const regex = new RegExp(/^\/start-today-app-view\/./, 'i');

export function isStartTodayUrl(url) {
  return regex.test(url);
}
